import React, { useEffect } from 'react';
import { Button } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

import DisplayPdf from '../../../../shared/DisplayPdf';
import { getFileExtension, sanitizeFileName } from '../../../../../helper/utils.helper';

const PdfPage = ({ section, setVisitedPages }) => {
  useEffect(() => {
    setVisitedPages((prevState) => ({
      ...prevState,
      [section.id]: true
    }));
  }, []);

  const handleDownload = async () => {
    try {
      const response = await fetch(section.resourceUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const title = sanitizeFileName(section.name);
      const fileExtension = getFileExtension(section.resourceUrl);
      const filename = `${title}.${fileExtension}`;

      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading the file', error);
    }
  };

  return (
    <div className="pdf-wrapper">
      <h4>{section.name}</h4>
      <div className="margin-top--md">
        {section?.body?.map((section, i) =>
          section.type === 'points' ? (
            <ul key={i}>
              {section.text.map((text) => (
                <li className="margin-top--sm" key={text}>
                  {text}
                </li>
              ))}
            </ul>
          ) : (
            section.text.map((text) => (
              <p className="margin-top--sm" key={text}>
                {text}
              </p>
            ))
          )
        )}
      </div>
      {section && section.resourceUrl && <DisplayPdf resourceUrl={section.resourceUrl} />}
      <Button
        style={{ margin: '20px 0px', textTransform: 'none' }}
        endIcon={<FileDownloadOutlinedIcon color="primary" />}
        onClick={handleDownload}>
        {decodeURIComponent(section.resourceUrl).split('#')[0].split('?')[0].split('/').pop()}
      </Button>
      <style jsx>
        {`
          .pdf-wrapper {
            padding: 0px 40px;
          }
          @media only screen and (max-width: 600px) {
            .pdf-wrapper {
              padding: 0px 20px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default PdfPage;
